import React from 'react' // eslint-disable-line
import styled from 'styled-components'

const SwatchContainer = styled.div`
  position: relative;
  right: 0;
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  z-index: ${({ editing }) => (editing ? 10 : 0)};
`

export default SwatchContainer



// WEBPACK FOOTER //
// ./src/components/Swatch/Container.js